import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#626C9D",
      d: "M5.734 10.734A1.037 1.037 0 0 1 7.2 9.267l4.8 4.799 4.798-4.8.08-.07a1.038 1.038 0 0 1 1.459 1.459l-.071.079-5.533 5.533a1.037 1.037 0 0 1-1.467 0z"
    }, null, -1)
  ])))
}
export default { render: render }